<template>
    <div class="category-filter">
        <div class="mb-5" @click="expanded = !expanded">
            <span class="clickable">
                <i class="fas mr-4" :class="{'fa-plus-square': !expanded, 'fa-minus-square': expanded}"></i>
                <span class="has-text-weight-bold">Course Categories</span>
            </span>
        </div>

        <div class="ml-5 pl-2 mb-5" v-if="expanded">
            <template v-if="loadingCategories">
                <p class="has-text-grey-light is-size-7">
                    <i class="fas fa-spinner fa-spin mr-2"></i>Loading categories...
                </p>
            </template>

            <template v-else-if="categories && categories.length > 0">
                <!-- All Categories toggle -->
                <b-field class="mb-2">
                    <b-switch
                        size="is-small"
                        :value="selectedCategories.length === 0"
                        @input="clearSelection"
                    >
                        All Categories
                    </b-switch>
                </b-field>

                <!-- Dynamic categories from API -->
                <template v-for="category in categories">
                    <b-field class="mb-1" :key="category.id">
                        <b-switch
                            size="is-small"
                            :value="isSelected(category.id)"
                            @input="toggle(category)"
                        >
                            {{ category.title }}
                        </b-switch>
                    </b-field>

                    <!-- Subcategories -->
                    <template v-if="category.children && category.children.length > 0">
                        <b-field
                            class="mb-1 ml-4"
                            v-for="child in category.children"
                            :key="child.id"
                        >
                            <b-switch
                                size="is-small"
                                :value="isSelected(child.id)"
                                @input="toggle(child)"
                            >
                                {{ child.title }}
                            </b-switch>
                        </b-field>
                    </template>
                </template>
            </template>

            <template v-else>
                <p class="has-text-grey-light is-size-7">
                    No categories available.
                </p>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'CategoryFilter',
    props: {
        certificationId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            expanded: false
        };
    },
    computed: {
        ...mapGetters(['categories', 'selectedCategories', 'loadingCategories'])
    },
    methods: {
        ...mapActions(['getCategories', 'toggleCategorySelection', 'clearCategorySelection']),
        isSelected(categoryId) {
            return this.selectedCategories.some(c => c.id === categoryId);
        },
        toggle(category) {
            this.toggleCategorySelection(category);
            this.$emit('filter-changed', this.selectedCategories);
        },
        clearSelection() {
            if (this.selectedCategories.length > 0) {
                this.clearCategorySelection();
                this.$emit('filter-changed', []);
            }
        },
        loadCategories() {
            if (this.certificationId) {
                this.getCategories(this.certificationId);
            }
        }
    },
    watch: {
        certificationId: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.loadCategories();
                }
            }
        }
    },
    mounted() {
        this.loadCategories();
    }
};
</script>

<style lang="scss" scoped>
.category-filter {
    .clickable {
        cursor: pointer !important;
    }
}
</style>
